import { EventBaseData } from "../../shared/models/event.model";
export class GlobalErrorEventModel extends EventBaseData {
  constructor(
    public HttpStatus: number,
    public IsTimeout: boolean, public CorrelationId ? :string) {
    super();
  }
}
